const MODAL_ADD_BIENEST = 'MODAL_ADD_BIENEST'
const MODAL_DET_BIENEST = 'MODAL_DET_BIENEST'
const MODAL_GES_BIENEST = 'MODAL_GES_BIENEST'
const MODAL_ADD_FILTRO_BIENEST = 'MODAL_ADD_FILTRO_BIENEST'
const MODAL_OBS_BIENEST = 'MODAL_OBS_BIENEST'
const MODAL_FORMATOS_BIENEST = 'MODAL_FORMATOS_BIENEST'
const MODAL_MATERIAL_APOYO_BIENEST = 'MODAL_MATERIAL_APOYO_BIENEST'
const MODAL_CONFIRMAR_REMI_BIENEST = 'MODAL_CONFIRMAR_REMI_BIENEST'
const MODAL_DET_BIENEST_FORMATOS = 'MODAL_DET_BIENEST_FORMATOS'
const MODAL_ASIGNAR_PROFESIONAL_BIENEST = 'MODAL_ASIGNAR_PROFESIONAL_BIENEST'

const mostrarModalDetalleBienestarFormatos = show => {
  return {
    type: MODAL_DET_BIENEST_FORMATOS,
    show,
  }
}

const mostrarModalAddFiltrosBienestar = (show, mostrarCampos = true) => {
  return {
    type: MODAL_ADD_FILTRO_BIENEST,
    show,
    mostrarCampos,
  }
}

const mostrarModalObservacionBienestar = show => {
  return {
    type: MODAL_OBS_BIENEST,
    show,
  }
}

const mostrarModalGestionarBienestar = show => {
  return {
    type: MODAL_GES_BIENEST,
    show,
  }
}

const mostrarModalDetalleBienestar = show => {
  return {
    type: MODAL_DET_BIENEST,
    show,
  }
}

const mostrarModalAddBienestar = show => {
  return {
    type: MODAL_ADD_BIENEST,
    show,
  }
}

const mostrarModalFormatosBienestar = show => {
  return {
    type: MODAL_FORMATOS_BIENEST,
    show,
  }
}

const mostrarModalMaterialApoyoBienestar = show => {
  return {
    type: MODAL_MATERIAL_APOYO_BIENEST,
    show,
  }
}

const mostrarModalConfirmarRemisionBienestar = show => {
  return {
    type: MODAL_CONFIRMAR_REMI_BIENEST,
    show,
  }
}

const mostrarModalAsignarProfesionalBienestar = show => {
  return {
    type: MODAL_ASIGNAR_PROFESIONAL_BIENEST,
    show,
  }
}


module.exports = {
  MODAL_ADD_BIENEST,
  MODAL_DET_BIENEST,
  MODAL_GES_BIENEST,
  MODAL_OBS_BIENEST,
  MODAL_FORMATOS_BIENEST,
  MODAL_MATERIAL_APOYO_BIENEST,
  MODAL_CONFIRMAR_REMI_BIENEST,
  MODAL_ADD_FILTRO_BIENEST,
  MODAL_DET_BIENEST_FORMATOS,
  MODAL_ASIGNAR_PROFESIONAL_BIENEST,
  mostrarModalAddBienestar,
  mostrarModalDetalleBienestar,
  mostrarModalGestionarBienestar,
  mostrarModalConfirmarRemisionBienestar,
  mostrarModalAddFiltrosBienestar,
  mostrarModalObservacionBienestar,
  mostrarModalFormatosBienestar,
  mostrarModalMaterialApoyoBienestar,
  mostrarModalDetalleBienestarFormatos,
  mostrarModalAsignarProfesionalBienestar
}
